import Vue from 'vue';
import { AssetsPhotoActions, AssetsPhotoStubActionable } from '@/services/assets-api/AssetsPhotoService';

export const deletePhotoNoRequest = (photoToDelete: AssetsPhotoStubActionable) => {
  Vue.set(photoToDelete, 'action', AssetsPhotoActions.DELETE_IMAGE);
  Vue.set(photoToDelete, 'image', null);
  Vue.set(photoToDelete, 'image_id', null);
  Vue.set(photoToDelete, 'drawing', null);
  Vue.set(photoToDelete, 'drawing_id', null);
};

export const deletePhoto = (photoToDelete: AssetsPhotoStubActionable) => {
  Vue.set(photoToDelete, 'action', AssetsPhotoActions.DELETE_IMAGE);
  Vue.set(photoToDelete, 'image_id_delete', photoToDelete.image_id);
  Vue.set(photoToDelete, 'drawing_id_delete', photoToDelete.drawing_id);

  deletePhotoNoRequest(photoToDelete);
};

export const deleteDrawing = (photoToDelete: AssetsPhotoStubActionable) => {
  if (photoToDelete.drawing_id) {
    Vue.set(photoToDelete, 'action', AssetsPhotoActions.DELETE_DRAWING);
    Vue.set(photoToDelete, 'drawing_id_delete', photoToDelete.drawing_id);
  }
  if (photoToDelete.action === AssetsPhotoActions.ADD_IMAGE_WITH_DRAWING) {
    Vue.set(photoToDelete, 'action', AssetsPhotoActions.ADD_IMAGE);
  }
  Vue.set(photoToDelete, 'drawing_id', null);
  Vue.set(photoToDelete, 'drawing', null);
};

export const updateDrawing = (photoToUpdate: AssetsPhotoStubActionable, drawing: string) => {
  if (photoToUpdate.action !== AssetsPhotoActions.ADD_IMAGE) {
    Vue.set(photoToUpdate, 'action', AssetsPhotoActions.UPDATE_DRAWING);
  }
  if (photoToUpdate.action === AssetsPhotoActions.ADD_IMAGE) {
    Vue.set(photoToUpdate, 'action', AssetsPhotoActions.ADD_IMAGE_WITH_DRAWING);
  }
  Vue.set(photoToUpdate, 'drawing', drawing);
  Vue.set(photoToUpdate, 'drawing_id', null);
};

export const addImage = (photoToAdd: AssetsPhotoStubActionable, photo: string) => {
  Vue.set(photoToAdd, 'action', AssetsPhotoActions.ADD_IMAGE);
  Vue.set(photoToAdd, 'image', photo);
  Vue.set(photoToAdd, 'image_id', null);
};
